<template>
  <div :class="$style.card">
    <div class="text-center">
      <img
        :src="item.image"
        :class="$style.image || styleClass.image"
        class="img-fluid"
      >
    </div>
    <JoinTitleParagraph
      :item="item"
      :style-class="{
        title: styleClass.title,
        paragraph: styleClass.paragraph,
      }"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import JoinTitleParagraph, { StyleClass as JoinTitleParagraphStyleClass, JoinTitleParagraphProps } from './JoinTitleParagraph.ts.vue';

export interface StyleClass extends JoinTitleParagraphStyleClass {
  image?: string;
}

export interface GraphicalCardItemProps extends JoinTitleParagraphProps {
  image: string;
}

export default Vue.extend({
  components: {
    JoinTitleParagraph,
  },
  props: {
    item: {
      type: Object as PropType<GraphicalCardItemProps>,
      required: true,
    },
    styleClass: {
      type: Object as PropType<StyleClass>,
      default: (): StyleClass => ({}),
    },
  },
});
</script>

<style module lang="scss">
.card {
  border-radius: 0.625rem;
  padding: 1.87500rem;

  // padding: 3rem;
}

.image {
  width: 204px;
  object-fit: contain;
  object-position: center;
}
</style>
